import { LexDatePipe } from '../../../../../../../pipes';
import { Utils } from '../../../../../../../utils/utils';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class SentimentScoreSummaryParameters implements AiSummaryTranslocoParameters {
  constructor(private lexDatePipe: LexDatePipe) {}

  assembleParameters(selectedPoints: any[], widget: any) {
    const translationKey = `widgets.ai-insights.summary.${widget.payload.type}.${widget.payload.aggregator}`;

    return selectedPoints
      .flatMap((p) => p)
      .map((p, idx) => {
        const fieldValue = widget.payload.analyticItem === 'documents' ? 'documents' : p.pointId;

        return {
          translationKey: `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`,
          translationParams: {
            fieldValue,
            score: Utils.round(p.y),
            date: this.lexDatePipe.transform(p.category, 'long'),
          },
        };
      });
  }
}
